import {DOCUMENT__LOADED_DETAILS} from '../../app/AppConstants';
import {getDocumentDetails, uploadDocument} from './documentService';

export function loadDocumentDetails(id) {
  return dispatch => {
    return getDocumentDetails(id).then(details => {
      dispatch({
        type: DOCUMENT__LOADED_DETAILS,
        payload: details,
      });

      return details;
    });
  };
}

export function createDocument(file, name) {
  return dispatch => {
    return uploadDocument(file, name).then(response => {
      return loadDocumentDetails(response.dataFileId)(dispatch);
    });
  };
}
